// Plan limits shown in the app. The server enforces them and must match:
// generations in verify-payment (planLimits) and sectionEdits in
// SECTION_EDITS_PER_PLAN, both in the Edge Function.
// sectionEdits: AI section edits ("Regenerate with AI") per period.
export const BASE_PRICING = {
  free: { price: { usd: 0, inr: 0 }, profiles: 1, generations: 3, sectionEdits: 5 },
  starter: { price: { usd: 2, inr: 50 }, profiles: 1, generations: 10, sectionEdits: 20 },
  plus: { price: { usd: 5, inr: 150 }, profiles: 2, generations: 50, sectionEdits: 100 },
  pro: { price: { usd: 10, inr: 300 }, profiles: 3, generations: 200, sectionEdits: 500 },
} as const;

export const MULTI_MONTH_COUNT = 3;
export const MULTI_MONTH_DISCOUNT_MULTIPLIER = 0.82; // 18% discount on 3x price

export const INDIA_TIMEZONE_HINTS = ["Asia/Kolkata", "Asia/Calcutta"];
export const INDIA_LANGUAGE_HINTS = ["hi", "en-IN"];

// Price of one AI generation on a plan, counting both credits (resume
// generations and AI section edits): perGeneration(50, 10 + 20, "₹") -> "₹1.7".
export function perGeneration(price: number, totalGenerations: number, currency: string) {
  const each = price / totalGenerations;
  return `${currency}${each >= 1 ? Math.round(each * 10) / 10 : each.toFixed(2)}`;
}
